export default __webpack_public_path__ + "static/media/cp_geo_gy.e948cf4f.svg";